import {
  currentOrPastDateUI,
  selectUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { futureDateUI, validateDateRange } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';
import { validateServiceEntryAge } from '../../../../utils/validation';

const TITLE_TEXT = content['service-info--last-period-title'];
const INPUT_LABELS = {
  branch: content['service-info--last-period-branch-label'],
  startDate: content['service-info--service-start-date-label'],
  endDate: content['service-info--service-end-date-label'],
  character: content['service-info--last-period-character-label'],
};

const BRANCH_SCHEMA_LABELS = {
  'air force': content['service-info--last-period-branch-option--airforce'],
  army: content['service-info--last-period-branch-option--army'],
  'coast guard': content['service-info--last-period-branch-option--coastguard'],
  'marine corps': content['service-info--last-period-branch-option--marines'],
  'merchant seaman': content['service-info--last-period-branch-option--seaman'],
  navy: content['service-info--last-period-branch-option--navy'],
  noaa: content['service-info--last-period-branch-option--noaa'],
  'space force': content['service-info--last-period-branch-option--spaceforce'],
  usphs: content['service-info--last-period-branch-option--usphs'],
  'f.commonwealth': content['service-info--last-period-branch-option--fcommon'],
  'f.guerilla': content['service-info--last-period-branch-option--fguerilla'],
  'f.scouts new': content['service-info--last-period-branch-option--fnewscout'],
  'f.scouts old': content['service-info--last-period-branch-option--foldscout'],
  other: content['service-info--last-period-branch-option--other'],
};

const CHARACTER_SCHEMA_LABELS = {
  honorable: content['service-info--last-period-character-option--honorable'],
  general: content['service-info--last-period-character-option--general'],
  other: content['service-info--last-period-character-option--other'],
  'bad-conduct': content['service-info--last-period-character-option--conduct'],
  dishonorable:
    content['service-info--last-period-character-option--dishonorable'],
  undesirable:
    content['service-info--last-period-character-option--undesirable'],
};

const VALIDATIONS = {
  age: [validateServiceEntryAge],
  range: [
    validateDateRange({
      startDateKey: 'lastEntryDate',
      endDateKey: 'lastDischargeDate',
      rangeErrorMessage: content['validation-error--service-date-range'],
    }),
  ],
};

const { lastDischargeDate, lastEntryDate, lastServiceBranch, dischargeType } =
  FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    lastServiceBranch: selectUI({
      title: INPUT_LABELS.branch,
      labels: BRANCH_SCHEMA_LABELS,
    }),
    lastEntryDate: currentOrPastDateUI({
      title: INPUT_LABELS.startDate,
      validations: VALIDATIONS.age,
    }),
    lastDischargeDate: futureDateUI(INPUT_LABELS.endDate),
    dischargeType: selectUI({
      title: INPUT_LABELS.character,
      labels: CHARACTER_SCHEMA_LABELS,
    }),
    'ui:validations': VALIDATIONS.range,
  },
  schema: {
    type: 'object',
    properties: {
      lastServiceBranch,
      lastEntryDate,
      lastDischargeDate,
      dischargeType,
    },
    required: [
      'lastServiceBranch',
      'lastEntryDate',
      'lastDischargeDate',
      'dischargeType',
    ],
  },
};
